import type { SearchModification } from 'Src/types/search';

export const DEFAULT_COMMON_SEARCHES = [
  'Primary Care',
  'Urgent Care',
  'Pediatrics',
  "Women's Health",
  'Hospital',
  'Behavioral Health',
  ''
];

export const NO_RESULTS_LINKS_BASE_QUERY_MODS: SearchModification[] = [
  { action: 'delete_key', key: 'unified' },
  { action: 'delete_key', key: 'filter' }
];
